import moment from 'moment';
import vuei18n from '@/plugins/vue-i18n';

export const statusTypes = {
  billStatus: [
    {
      text: 'rcm.filtersText.statusAccounts.inProgress',
      value: 'IN_PROGRESS'
    },
    {
      text: 'rcm.filtersText.statusAccounts.invoiced',
      value: 'INVOICED'
    },
    {
      text: 'rcm.filtersText.statusAccounts.packageGenerated',
      value: 'PACKAGE_GENERATED'
    },
    {
      text: 'rcm.filtersText.statusAccounts.pendingAudit',
      value: 'PENDING_AUDIT'
    },
    {
      text: 'rcm.filtersText.statusAccounts.sent',
      value: 'SENT'
    },
    {
      text: 'rcm.filtersText.statusAccounts.settled',
      value: 'SETTLED'
    },
		{
      text: 'rcm.filtersText.statusAccounts.voided',
      value: 'VOIDED'
    }
  ],
  statusHealthcarePlanCoverage: [
    {
      text: 'rcm.filtersText.statusHealthcarePlanCoverage.pos',
      value: 'PBS'
    },
    {
      text: 'rcm.filtersText.statusHealthcarePlanCoverage.notPos',
      value: 'NPBS'
    }
  ],
  statusDocument: [
    { text: 'rcm.filtersText.statusDocumentation.completed', value: 'true' },
    { text: 'rcm.filtersText.statusDocumentation.incomplete', value: 'false' }
  ],
  statusPayers: [
    {
      text: 'rcm.filtersText.statusPayers.nuevaEps',
      value: 'Nueva EPS'
    }
  ],
  accountChargesServiceTypes: [
    {
      text: 'rcmAccountDetail.charges.serviceTypes.hospitalization',
      value: 'HOSPITALIZACION'
    },
    {
      text: 'rcmAccountDetail.charges.serviceTypes.urgency',
      value: 'URGENCIAS'
    },
    {
      text: 'rcmAccountDetail.charges.serviceTypes.outpatientCare',
      value: 'CONSULTA EXTERNA'
    },
    {
      text: 'rcmAccountDetail.charges.serviceTypes.procedure',
      value: 'PROCEDIMIENTO'
    },
    {
      text: 'rcmAccountDetail.charges.serviceTypes.exam',
      value: 'EXAMEN'
    }
  ],
  relationLevels: [
    {
      text: 'supportsAdministrator.relations.account',
      value: 'ACCOUNT',
    },
    {
      text: 'supportsAdministrator.relations.charge',
      value: 'CHARGE',
    },
    {
      text: 'supportsAdministrator.relations.event',
      value: 'EVENT',
    }
  ],
  concurrent: [
    {
      text: 'rcm.filtersText.statusConcurrent',
      value: true,
    }
  ],
  accountValidationStatus: [
    {
      text: 'rcm.filtersText.statusAccounts.inProgress',
      value: 'ACCOUNT_VALIDATION'
    }
  ],
  reassignedAccount: [
    { text: 'rcm.filtersText.reassignedAccount.reassigned', value: 'true' }
  ]
};

export const filtersConfiguration = [
  {
    type: 'SELECT',
    text: 'rcm.filters.statusDocumentation',
    items: statusTypes.statusDocument,
    multipleSelection: false,
    section: 'rcm',
    category: 'rcm-status-documentation',
    mobile: true,
    customIcon: {
      required: true,
      icon: 'arrow_drop_down',
      iconClass: 'custom-icon-color'
    }
  },
  {
    type: 'AUTOCOMPLETE',
    text: 'rcm.filters.missingSupports',
    noDataText: 'rcm.filters.noResultsFound',
    items: [],
    multipleSelection: true,
    visibleItems: 1,
    range: null,
    section: 'rcm',
    category: 'rcm-missing-supports',
    mobile: true,
    prependIcon: null,
    prependAction: null,
    customIcon: {
      required: true,
      icon: 'arrow_drop_down',
      iconClass: 'custom-icon-color'
    },
  },
  {
    type: 'SELECT',
    text: 'rcm.filters.invoiceNumberStatus',
    items: statusTypes.billStatus,
    multipleSelection: true,
    range: null,
    section: 'rcm',
    category: 'rcm-status-account',
    mobile: true,
    prependIcon: null,
    prependAction: true,
    customIcon: {
      required: true,
      icon: 'arrow_drop_down',
      iconClass: 'custom-icon-color'
    }
  },
  {
    type: 'SELECT',
    text: 'rcm.filters.serviceType',
    items: [],
    multipleSelection: true,
    section: 'rcm',
    category: 'rcm-account-service-types',
    mobile: true,
    customIcon: {
      required: true,
      icon: 'arrow_drop_down',
      iconClass: 'custom-icon-color'
    },
  },
	{
    type: 'SELECT',
    text: 'rcm.filters.agreement',
    items: [],
    multipleSelection: true,
    range: null,
    section: 'rcm',
    category: 'rcm-provider-agreement',
    mobile: true,
    prependIcon: null,
    prependAction: true,
    customIcon: {
      required: true,
      icon: 'arrow_drop_down',
      iconClass: 'custom-icon-color'
    }
  },
  {
    type: 'DATE-FROM',
    text: 'rcm.filters.from',
    items: null,
    multipleSelection: false,
    range: true,
    section: 'rcm',
    category: 'date-range',
    mobile: true,
    prependIcon: null,
    prependAction: true,
    minDate: null,
    maxDate: moment().format('YYYY-MM-DD'),
    customIcon: {
      required: true,
      icon: 'mdi-calendar',
      iconClass: 'custom-icon-color'
    }
  },
  {
    type: 'DATE-TO',
    text: 'rcm.filters.to',
    items: null,
    multipleSelection: false,
    range: true,
    section: 'rcm',
    category: 'date-range',
    mobile: true,
    prependIcon: null,
    prependAction: true,
    minDate: null,
    maxDate: moment().format('YYYY-MM-DD'),
    customIcon: {
      required: true,
      icon: 'mdi-calendar',
      iconClass: 'custom-icon-color'
    }
  },
  {
    type: 'SELECT',
    text: 'rcm.filters.executorServices',
    items: [],
    multipleSelection: true,
    section: 'rcm',
    category: 'rcm-account-executor-services',
    mobile: true,
    customIcon: {
      required: true,
      icon: 'arrow_drop_down',
      iconClass: 'custom-icon-color'
    },
  },
  {
    type: 'SELECT',
    text: 'rcm.filters.agreementPlanTypes',
    items: [],
    multipleSelection: true,
    section: 'rcm',
    category: 'rcm-account-agreement-plan-types',
    mobile: true,
    customIcon: {
      required: true,
      icon: 'arrow_drop_down',
      iconClass: 'custom-icon-color'
    },
  },
  {
    type: 'SELECT',
    text: 'rcm.filters.invoiceSource',
    items: [],
    multipleSelection: true,
    section: 'rcm',
    category: 'rcm-invoice-sources',
    mobile: true,
    customIcon: {
      required: true,
      icon: 'arrow_drop_down',
      iconClass: 'custom-icon-color'
    },
  },
  {
    type: 'SELECT',
    text: 'rcm.filters.statusHealthcarePlanCoverage',
    items: statusTypes.statusHealthcarePlanCoverage,
    multipleSelection: true,
    range: null,
    section: 'rcm',
    category: 'rcm-status-healthcare',
    mobile: true,
    prependIcon: null,
    prependAction: true,
    customIcon: {
      required: true,
      icon: 'arrow_drop_down',
      iconClass: 'custom-icon-color'
    }
  },
  {
    type: 'SELECT',
    text: 'rcm.filters.concurrent',
    items: statusTypes.concurrent,
    multipleSelection: true,
    range: null,
    section: 'rcm',
    category: 'rcm-status-concurrent',
    mobile: true,
    prependIcon: null,
    prependAction: true,
    customIcon: {
      required: true,
      icon: 'arrow_drop_down',
      iconClass: 'custom-icon-color'
    }
  },
  {
    type: 'INPUT',
    text: 'rcm.filters.minAmount',
    items: null,
    multipleSelection: null,
    range: null,
    section: 'rcm',
    category: 'rcm-status-min-amount',
    mobile: true,
    prependIcon: null,
    prependAction: true,
    prefix: null,
    suffix: 'rcm.filters.currency',
    useCurrency: true,
    typeInput: 'number',
    customIcon: {
      required: null,
      icon: null,
      iconClass: null
    }
  },
  {
    type: 'INPUT',
    text: 'rcm.filters.maxAmount',
    items: null,
    multipleSelection: null,
    range: null,
    section: 'rcm',
    category: 'rcm-status-max-amount',
    mobile: true,
    prependIcon: null,
    prependAction: null,
    prefix: null,
    suffix: 'rcm.filters.currency',
    useCurrency: true,
    typeInput: 'number',
    customIcon: {
      required: null,
      icon: null,
      iconClass: null
    }
  },
  {
    type: 'AUTOCOMPLETE',
    text: 'rcm.filters.responsibleAssigned',
    noDataText: 'rcm.filters.noResultsFound',
    items: [],
    multipleSelection: true,
    visibleItems: 1,
    range: null,
    section: 'rcm',
    category: 'rcm-responsible-assigned',
    mobile: true,
    prependIcon: null,
    prependAction: null,
    customIcon: {
      required: true,
      icon: 'arrow_drop_down',
      iconClass: 'custom-icon-color'
    },
  },
  {
    type: 'SELECT',
    text: 'rcm.filters.reassignedAccount',
    items: statusTypes.reassignedAccount,
    multipleSelection: false,
    section: 'rcm',
    category: 'rcm-reassigned-account',
    mobile: true,
    customIcon: {
      required: true,
      icon: 'arrow_drop_down',
      iconClass: 'custom-icon-color'
    }
  }
];

export const drawerAddOns = [
  {
    title: 'rcm.drawer.labels.accounts',
    component: 'DefaultButtonsAddOn',
    order: 1,
    routesPatterns: ['/rcm/home', '/rcm/*'],
    isExpansionPanel: false
  }
];

export const accountChargesFilters = [
  {
    type: 'SELECT',
    text: 'rcmAccountDetail.charges.serviceType',
    items: statusTypes.accountChargesServiceTypes,
    multipleSelection: true,
    range: null,
    section: 'rcm',
    category: 'rcm.account-charges.service-types',
    mobile: true,
    prependIcon: null,
    prependAction: true,
    customIcon: {
      required: true,
      icon: 'arrow_drop_down',
      iconClass: 'custom-icon-color'
    }
  },
  {
    type: 'DATE',
    text: 'rcmAccountDetail.charges.from',
    items: null,
    multipleSelection: false,
    range: true,
    section: 'rcm',
    category: 'rcm.account-charges.date-from',
    mobile: true,
    prependIcon: null,
    prependAction: true,
    minDate: null,
    maxDate: moment().format('YYYY-MM-DD'),
    customIcon: {
      required: true,
      icon: 'mdi-calendar',
      iconClass: 'custom-icon-color'
    }
  },
  {
    type: 'DATE',
    text: 'rcmAccountDetail.charges.to',
    items: null,
    multipleSelection: false,
    range: true,
    section: 'rcm',
    category: 'rcm.account-charges.date-to',
    mobile: true,
    prependIcon: null,
    prependAction: true,
    minDate: null,
    maxDate: moment().format('YYYY-MM-DD'),
    customIcon: {
      required: true,
      icon: 'mdi-calendar',
      iconClass: 'custom-icon-color'
    }
  }
];

export const supportsAdministratorFilters = [
  {
    type: 'SELECT',
    text: 'supportsAdministrator.filters.relation',
    items: statusTypes.relationLevels,
    multipleSelection: true,
    range: null,
    section: 'rcm',
    category: 'rcm.supports-administrator.pending.relation',
    mobile: false,
    prependIcon: null,
    prependAction: true,
    customIcon: {
      required: true,
      icon: 'arrow_drop_down',
      iconClass: 'custom-icon-color'
    }
  },
  {
    type: 'SELECT',
    text: 'supportsAdministrator.filters.relation',
    items: statusTypes.relationLevels,
    multipleSelection: true,
    range: null,
    section: 'rcm',
    category: 'rcm.supports-administrator.received.relation',
    mobile: false,
    prependIcon: null,
    prependAction: true,
    customIcon: {
      required: true,
      icon: 'arrow_drop_down',
      iconClass: 'custom-icon-color'
    }
  }
];

export const backgroundColor = {
  principalBackgroundColor: '#FAFAFA',
  secondaryBackgroundColor: '#E4F0FF',
  transparentBackgroundColor: 'transparent !important'
};

export const accountActions = () => [
  {
    slug: 'MOVE_TO_PACKAGE_GENERATED',
    title: vuei18n.t('rcm.accountsActions.moveToReadyToSettlement'),
    status: 'VOIDED'  // This voided is related to the settlement process not to disable an account
  },
  {
    slug: 'MOVE_TO_SENT',
    title: vuei18n.t('rcm.accountsActions.moveToSent'),
    status: 'SENT'
  },
  {
    slug: 'MOVE_TO_SETTLED',
    title: vuei18n.t('rcm.accountsActions.moveToSettled'),
    status: 'SETTLED'
  },
  {
    slug: 'DISABLE_ACCOUNTS',
    title: vuei18n.t('rcm.accountsActions.disableAccounts'),
    status: 'DISABLE_ACCOUNT'
  },
  {
    slug: 'VALIDATE_ACCOUNTS',
    title: vuei18n.t('rcm.validateAccountNotifications.filter'),
    status: 'ACCOUNT_VALIDATION'
  },
  {
    slug: 'ASSIGN_RESPONSIBLE',
    title: vuei18n.t('rcm.accountsActions.assignResponsible'),
  },
  {
    slug: 'CLEAN_PACKAGE_FOLDER',
    title: vuei18n.t('rcm.accountsActions.cleanPackageFolder'),
  }
];

export const preSettlementsActions = () => [
  {
    slug: 'BUILD_ACCOUNTS',
    title: vuei18n.t('preSettlements.labels.generateAccountButton'),
  },
  {
    slug: 'MOVE_TO_SENT',
    title: vuei18n.t('preSettlements.actions.setAccountsAsSent'),
    preSettlementStatus: 'SENT'
  },
  {
    slug: 'MOVE_TO_SETTLED',
    title: vuei18n.t('preSettlements.actions.setAccountsAsSettled'),
    preSettlementStatus: 'SETTLED'
  },
  {
    slug: 'MOVE_TO_GENERATED',
    title: vuei18n.t('preSettlements.actions.setAccountsAsPackageGenerated'),
    preSettlementStatus: 'GENERATED'
  },
  {
    slug: 'MOVE_TO_RIPS_VALIDATION_ERRORS',
    title: vuei18n.t('preSettlements.actions.setAccountsAsRipsValidationErrors'),
    preSettlementStatus: 'RIPS_VALIDATION_ERRORS'
  }
];

export const validateAccountNotifications = (wording = '') => {
	const wordings = {
		inProgressWording: vuei18n.t('rcm.validateAccountNotifications.inProgressWording'),
		completedWording: vuei18n.t('rcm.validateAccountNotifications.completedWording'),
		errorWording: vuei18n.t('rcm.validateAccountNotifications.errorWording'),
		started: vuei18n.t('rcm.validateAccountNotifications.status.started'),
		inProgress: vuei18n.t('rcm.validateAccountNotifications.status.inProgress'),
		completed: vuei18n.t('rcm.validateAccountNotifications.status.completed'),
		error: vuei18n.t('rcm.validateAccountNotifications.status.error')
	};

	return wordings[wording];
}

export const mimeTypes = ["image/png", "image/jpeg", "application/xml", "text/xml", "application/pdf", "application/json", "application/zip", "application/x-zip-compressed", "text/plain"];
